import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setFilter, cleanState } from '../../../../actions';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import logoUruk from '../../logos/urukcolor.png';
import Tour from './Tour';

import { Auth } from 'aws-amplify';
import { styles } from './styles';
import ButtonsToolbar from './ButtonsToolbar';
import {
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Breadcrumbs,
  Link,
  Typography,
  Grid,
  withStyles,
  useTheme
} from '@material-ui/core';
import {
  FolderOutlined,
  DescriptionOutlined,
  PersonAddOutlined,
  ViewQuiltOutlined,
  PostAddOutlined,
  VerifiedUserOutlined,
  LibraryBooksOutlined,
  AccessTimeOutlined
} from '@material-ui/icons';
import Notifications from '../Notifications';
import AppNavMobile from './AppNavMobile';
import UserMenu from './UserMenu';
import Support from './Support';
import WorkspaceMenu from './WorkspaceMenu';
import useWindowSize from '../../../../customHooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import ChangeLanguage from './ChangeLanguage';
import SignerLink from './SignerLink';
import RenderLogoByHostname from '../../logos/RenderLogoByHostname';
import { recordAnalyticsEvent } from '../../../../Analytics/recordAnalyticsEvent';

const TopBar = (props) => {
  const [value, setValue] = useState(0);
  const windowSize = useWindowSize();
  const location = useLocation();
  const history = useHistory();
  const { classes } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const { visibleTabs, customTheme, subgroup, user, groups, group, setLoading, config: { role, enableTour, extraConfig } } = props;
  const urlSupport = JSON.parse(extraConfig.data).urlSupport;

  const showWorkspaces = groups.length > 1;

  const path = location.pathname.split('/');
  const last = path.pop();
  const { logo } = customTheme || { logo: logoUruk };

  function returnIcon (iconName) {
    switch (iconName) {
      case 'ViewQuiltOutlined': // Dashboard
        return <ViewQuiltOutlined />;
      case 'ViewListOutlined': // Templates
        return <DescriptionOutlined />;
      case 'EditOutlined': // Pending
        return <AccessTimeOutlined />;
      case 'PersonAddOutlined':
        return <PersonAddOutlined />;
      case 'FolderOutlined': // Finished
        return <FolderOutlined />;
      case 'PostAddOutlined': // File Registry
        return <PostAddOutlined />;
      case 'DynamicFeed': // Bundle
        return <LibraryBooksOutlined />;
      case 'MailOutline':
        return <VerifiedUserOutlined />;
      default:
    }
  }
  const selector = (path) => visibleTabs.findIndex(e => e.name === path);
  const statusDocument = location.pathname.split('/')[2] === 'finished' ? 'signed' : 'pending';
  const setTabsFocus = {
    'dashboard': selector('dashboard'),
    'template': selector('templates'),
    'document': selector(statusDocument),
    'identity': selector('identity'),
    'file': selector('file'),
    'bundle': selector('bundles'),
    'notification': selector('notification'),
    'default': selector(visibleTabs[0].name)
  };

  useEffect(() => {
    let tabValue = false;
    const path = location.pathname.split('/')[1];
    tabValue = setTabsFocus[path] || setTabsFocus['default'];
    tabValue = tabValue < 0 ? false : tabValue;
    setValue(tabValue);
  }, [location]);

  const handleLogout = async () => {
    await recordAnalyticsEvent('user.logout', {});
    await Auth.signOut().then(() => {
      history.push('/');
      props.resetState();
      sessionStorage.clear();
    }).catch((err) => console.error(err));
  };

  const handleTabChange = (event, value) => {
    setValue(value);
  };

  return (
    <>
      <AppBar color='secondary' position='static'>
        <Toolbar>
          {windowSize.width <= 990 &&
          <AppNavMobile
            user={user}
            handleLogout={handleLogout}
            visibleTabs={visibleTabs}
            returnIcon={returnIcon}
            setLoading={setLoading}
            logo={logo}
          />
          }
          {windowSize.width > 990 &&
            <div className={classes.container_logo}>
              <RenderLogoByHostname customLogo={logo} topBar classNameLogo={classes.logo} />
            </div>
          }
          <div className={classes.container_user}>
            <Grid >
              <Grid
                container
                justify='center'
                alignItems='flex-end'
                direction='column'
                style={{ height: '100%' }}
              >
                <Typography
                  style={{
                    fontWeight: 'bold',
                    color: theme.palette.secondary.contrastText
                  }}
                >
                  {user.username}
                </Typography>
                <Typography
                  style={{
                    fontSize: 10,
                    textTransform: 'capitalize',
                    lineHeight: '16px',
                    color: theme.palette.secondary.contrastText
                  }}
                >
                  {showWorkspaces && <span>{`${group} / ${subgroup}: `}</span>}
                  <span>{role}</span>
                </Typography>
              </Grid>
            </Grid>
            {showWorkspaces && <WorkspaceMenu setLoading={setLoading} /> }
            <UserMenu user={user} handleLogout={handleLogout} />

            {windowSize.width > 990 &&
            <Notifications />
            }

            <Support user={user} url={urlSupport} />

            {windowSize.width > 990 &&
              <ChangeLanguage />
            }
            {windowSize.width > 990 &&
            <SignerLink />
            }
          </div>
        </Toolbar>
      </AppBar>
      <AppBar color='default' position='static'>
        <Toolbar disableGutters className={classes.toolBar}>
          <Tabs
            indicatorColor='primary'
            value={value}
            onChange={handleTabChange}
            variant='fullWidth'
            aria-label='Main tab panel'
            TabIndicatorProps={{ style: { filter: 'brightness(0.8)' } }}
          >
            {visibleTabs.map((tab, i) => (
              <Tab
                className={`dashboard-${tab.name}`}
                key={i}
                icon={returnIcon(tab.icon)}
                label={t(`topBar:${tab.label.toUpperCase()}`)}
                component={RouterLink}
                to={tab.url}
              />
            ))}
          </Tabs>
        </Toolbar>
      </AppBar>
      <AppBar position='relative'>
        <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Breadcrumbs aria-label='breadcrumb'>
            {path.map((name) => (
              <Link
                key={name}
                color='inherit'
                component={RouterLink}
                to={name ? `/${name}` : '/'}
              >
                {t(`breadcrumb:${name || 'home'}`, name.toUpperCase())}
              </Link>
            ))}
            {
              <Typography>
                {t(`breadcrumb:${last}`, last.toUpperCase())}
              </Typography>
            }
          </Breadcrumbs>
          <ButtonsToolbar {...history} />
          {enableTour && <Tour />}

        </Toolbar>
      </AppBar>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
    visibleTabs: state.config.visibleTabs,
    customTheme: state.config.theme,
    config: state.config,
    subgroup: state.config.subgroup,
    groups: state.config.groups,
    group: state.config.group,
    user: state.config.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (data) => dispatch(setFilter(data)),
    resetState: () => dispatch(cleanState())
  };
};

TopBar.propTypes = {
  customTheme: PropTypes.object,
  visibleTabs: PropTypes.array.isRequired,
  resetState: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  subgroup: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  group: PropTypes.string.isRequired,
  setLoading: PropTypes.func.isRequired

};

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(TopBar));
